import { Button, Input, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ErrorItem,
    InputNumberItem,
    DatePickerItem,
} from "../../../../Components/Items";

class AgregarCarrera extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
    };

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "carreras/agregarCarrera",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Carrera agregada exitosamente");
                    this.cerrarModalAgregarCarrera();
                } else if (res.data.success === 1) {
                    message.error("No se pudo agregar la carrera");
                } else {
                    message.error("Sucedió un error y no se pudo agregar la carrera");
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModalAgregarCarrera() {
        this.setState({ visible: false });
        this.props.cerrarModalAgregarCarrera();
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
    }

    render() {
        return (
            <ModalItem
                title="Agregar Carrera"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalAgregarCarrera.bind(this)}
                width={800}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="modalAgregarCarrera"
                    layout
                    bottom={
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            loading={this.state.loading}
                        >
                            Guardar
                        </Button>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem
                        label="Nombre"
                        name="nombre"
                        required
                    >
                        <Input placeholder="Nombre de la carrera" />
                    </FormItem>

                    <FormItem
                        label="Distancia (km)"
                        name="distancia"
                        required
                    >
                        <InputNumberItem min={1} placeholder="Distancia en kilómetros" style={{ width: "100%" }} />
                    </FormItem>

                    <FormItem
                        label="Precio ($)"
                        name="precio"
                        required
                    >
                        <InputNumberItem
                            placeholder="Precio de inscripción"
                            style={{ width: "100%" }}
                        />
                    </FormItem>

                    <FormItem
                        label="Fecha de la Carrera"
                        name="fechaCarrera"
                        required
                    >
                        <DatePickerItem />
                    </FormItem>

                    <FormItem
                        label="Hora de la Carrera"
                        name="horaCarrera"
                        required
                    >
                        <InputNumberItem placeholder="Hora de la Carrera" />
                    </FormItem>

                    <FormItem
                        label="Ubicación de la Carrera"
                        name="ubicacionCarrera"
                        required
                    >
                        <Input placeholder="Ubicación de la Carrera" />
                    </FormItem>

                    <FormItem
                        label="Fecha de Inicio de Inscripción"
                        name="fechaInicio"
                        required
                    >
                        <DatePickerItem />
                    </FormItem>

                    <FormItem
                        label="Fecha de Fin de Inscripción"
                        name="fechaFin"
                        required
                    >
                        <DatePickerItem />
                    </FormItem>

                    <FormItem
                        label="Observaciones"
                        name="observaciones"
                    >
                        <Input placeholder="Observaciones" />
                    </FormItem>

                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(AgregarCarrera);
